import Vue from 'vue';
import { constant } from '@/utils/helper';
Vue.mixin({
  data: function () {
    return {
      ...constant
    }
  },
  methods: {
    calMargin(bill) {
      bill.billItems.forEach((billItem) => {
        billItem.margin = billItem.total - (billItem.qty * billItem.buyPrice);
      });
    },
    getMap(mapName, noAutoLoad = false) {
      return this.$store.getters.getMap(mapName, noAutoLoad);
    },
    getArray(mapName, noAutoLoad = false, destroyClone = true) {
      return this.$store.getters.getArray(mapName, noAutoLoad, destroyClone);
    },
    getObject(value, mapName, property = 'id') {
      if(!value && value != 0) {
        return null;
      }
      return this.$store.getters.getObject(value, mapName, property);
    },
    printProperty(objectId, mapName, property = 'name' ) {
      const object = this.getObject(objectId, mapName);
      if(!object || (!object[property] && object[property] != 0)) return '...';
      return object[property];
    },
    printName(objectId, mapName) {
      return this.printProperty(objectId, mapName);
    },
    printDate(date, format = 'DD/MM/YYYY HH:mm') {
      if (!date) {
        return '';
      }
      if (typeof date === 'string') {
        date = date.replace(' ', 'T');
      }
      return this.$dayjs(date).format(format);
    },
    getColor(mapInfo) {
      return this.getMap('colors')[mapInfo];
    },
    detach(element, array) {
      const index = array.indexOf(element);
      if(index != -1) array.splice(index, 1);
    },
    can(permission) {
      const permissions = this.getMap('user', true)['permissions'];
      if(!permissions) return false;
      return permissions.includes(this.camelToSnake(permission));
    },
    camelToSnake(string) {
       var result = string.replace(/([A-Z])/g, " $1" );
       return result.split(' ').join('_').toLowerCase();
    },
  },
  computed: {
    hasCashierPermission() {
      return this.can('toggleStaffSignIn');
    },
    isActiveShiftCashier() {
      const user = this.getMap('user', true);
      const shift = user ? user.shift : null;
      if (!this.hasCashierPermission || !user || !shift || !shift.user) return false;
      const shiftUserId = typeof shift.user === 'object' ? shift.user.id : shift.user;
      return String(shiftUserId) === String(user.id);
    },
    canManageShiftStart() {
      const user = this.getMap('user', true);
      return this.hasCashierPermission && (!user || !user.shift);
    },
    canManageCashierFlow() {
      return this.isActiveShiftCashier || this.canManageShiftStart;
    },
    isCashier() {
      return this.isActiveShiftCashier;
    },
    getCloneList(map) {
      return this.$store.getters.getCloneList(map);
    },
    getClone(object, map, list = null) {
      return this.$store.getters.getClone(object, map, list);
    }
  }
});
